import {
  planAnalysis,
  type AnalysisDiagnostic,
  type AnalysisPlanError,
  type QueryPlan,
} from '@aibi/analysis-engine';
import type { AnalysisState } from '@aibi/contracts';
import { useMemo } from 'react';
import { useWorkspace } from './workspace-context';

export type CardPlan =
  | { readonly status: 'empty' }
  | {
      readonly status: 'planned';
      readonly plan: QueryPlan;
      readonly diagnostics: readonly AnalysisDiagnostic[];
    }
  | { readonly status: 'invalid'; readonly error: AnalysisPlanError };

/**
 * Planifica una tarjeta con el Analysis Engine (sin logica de planificacion propia).
 * Se recalcula solo cuando cambia el estado de la tarjeta o el modelo.
 */
export function useCardPlan(card: AnalysisState): CardPlan {
  const { model } = useWorkspace();
  return useMemo<CardPlan>(() => {
    if (card.dimensions.length === 0 && card.measures.length === 0) return { status: 'empty' };
    const planned = planAnalysis(card, model);
    return planned.ok
      ? { status: 'planned', plan: planned.value.plan, diagnostics: planned.value.diagnostics }
      : { status: 'invalid', error: planned.error };
  }, [card, model]);
}
